import { Entity, Field } from "typegraph";

// import Image from "../../entities/Image";
import User from "./User";

@Entity({one: "organization", many: "organizations"})
export default class OrganizationProducts {

	@Field()
	public id: string;

	@Field()
	public name: string;

	@Field({entity: User})
	public userList: User[];

}



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/entities/OrganizationUserlist.ts